import { api } from "../index.api";

const fetchJsonapi = async (selectedLanguage = "en", selectedCountry = "us") => {
  const langData = {
    countryCode: selectedCountry.toLocaleLowerCase(),
    language: selectedLanguage.toLowerCase(),
  };
  let data = {}
    // Wait for the API response
      await api.getselectedLanguage(langData, (res) => {
        if (res && res.json) {
          data = res.json; 
        } 
      });
      return data
    };


export default fetchJsonapi;



// WEBPACK FOOTER //
// ./src/mi-app/language/api.js